import { Component } from "@angular/core";
import {
  Loading,
  LoadingController,
  NavController,
  NavParams,
  ViewController,
} from "ionic-angular";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";
import Enumerable from "linq";
import { forkJoin } from "rxjs/observable/forkJoin";
import { DemoProvider } from "../../providers/demo/demo";
import moment from "moment";

@Component({
  selector: "page-kpi-details",
  templateUrl: "kpi-details.html",
})
export class KpiDetailsPage {
  public type: string;
  public from: string;
  public to: string;
  public currentValue: number;
  private id: number;
  public ready = false;
  public get title(): string {
    if (this.type === "trips") {
      return "Running trips";
    } else if (this.type === "starts") {
      return "Starts";
    } else if (this.type === "alarms") {
      return "Alarms";
    } else {
      return "Details";
    }
  }
  public starts = [];
  public trips = [];
  public alarms = [];
  filters: Array<string> = [];
  filter = "all";
  loader: Loading;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private viewCtrl: ViewController,
    private starms: StarmsClientProvider,
    private demo: DemoProvider,
    public loadingCtrl: LoadingController
  ) {
    this.loader = this.loadingCtrl.create({
      content: "Please wait",
      enableBackdropDismiss: true,
    });
  }

  ionViewDidLoad() {
    this.type = this.navParams.get("type");
    this.from = this.navParams.get("from");
    this.to = this.navParams.get("to");
    this.id = this.navParams.get("id");
    this.currentValue = this.navParams.get("current");
    if (this.type === "starts") {
      this.getSucessfulStarts();
    } else if (this.type === "trips") {
      this.getTrips();
    } else if (this.type === "alarms") {
      this.getAlarms();
    }
  }

  close(): void {
    this.viewCtrl.dismiss();
  }

  getSucessfulStarts(): void {
    this.loader.present();

    if (this.demo.demoMode) {
      // Mockup demo mode
      this.starts = [
        {
          downtime: null,
          assemblyName: "/03",
          siteTime: "2019-06-28T00:00:00.0000000+02:00",
          eventCategory: null,
          eventCategoryId: 252,
          eventDescription: "Initial State - Running on Gas",
          value: 0,
          currentStateId: null,
          tagId: 0,
          id: 0,
          isExternal: false,
          activeTimeStamp: null,
          timeStamp: null,
          eventStateIndicatorId: null,
          tagIdentifier: null,
        },
        {
          downtime: null,
          assemblyName: "/03",
          siteTime: "2019-07-22T00:13:04.9610000+02:00",
          eventCategory: null,
          eventCategoryId: 251,
          eventDescription: "Start Attempt Success",
          value: 0,
          currentStateId: null,
          tagId: 0,
          id: 0,
          isExternal: false,
          activeTimeStamp: null,
          timeStamp: null,
          eventStateIndicatorId: null,
          tagIdentifier: null,
        },
        {
          downtime: null,
          assemblyName: "/03",
          siteTime: "2019-07-26T11:35:04.8490000+02:00",
          eventCategory: null,
          eventCategoryId: 251,
          eventDescription: "Initial State - Running on Gas",
          value: 0,
          currentStateId: null,
          tagId: 0,
          id: 0,
          isExternal: false,
          activeTimeStamp: null,
          timeStamp: null,
          eventStateIndicatorId: null,
          tagIdentifier: null,
        },
      ];
      this.filters = Enumerable.from(this.starts)
        .select((x) => x["eventDescription"])
        .distinct()
        .toArray();
      this.ready = true;
      this.loader.dismiss();
    } else {
      // Get successful starts
      forkJoin(
        this.starms.get(["events/eventsoperationalsummary/trains/", this.id], {
          from: this.from,
          to: this.to,
        }),
        this.starms.get(["events/eventtypes"])
      ).subscribe(
        ([result]) => {
          this.starts = Enumerable.from(result)
            .orderByDescending((x) => x["siteTime"])
            .toArray()
            .map((s) => {
              const diff = moment.parseZone(s["siteTime"]).utcOffset();
              s["siteItem"] = Date.parse(
                moment(s["siteTime"]).add(diff, "minutes").toString()
              );
              return s;
            });
          this.filters = Enumerable.from(this.starts)
            .select((x) => x["eventDescription"])
            .distinct()
            .toArray();
          this.ready = true;
          this.loader.dismiss();
        },
        (error) => {
          console.log(error);
          this.ready = true;
          this.loader.dismiss();
        }
      );
    }
  }

  getTrips(): void {
    this.loader.present();

    if (this.demo.demoMode) {
      this.trips = [
        {
          downtime: 1945,
          eventDescription:
            "FLAME FAILURE - TEMPERATURE FALLING, THROTTLE LIMITING",
          occurrences: 1,
          tagAlias: "sdn 18213",
          tagId: 583,
        },
      ];
      this.ready = true;
      this.loader.dismiss();
    } else {
      this.starms
        .get(["events/eventparetos/trains/", this.id], {
          from: this.from,
          to: this.to,
          sortOrder: "DownTime",
          eventType: "RunningTrip",
        })
        .map((x) =>
          x.map((y) => {
            y.UIDownTime = new Date(y["downtime"] * 1000)
              .toUTCString()
              .match(/(\d\d:\d\d:\d\d)/)[0];
            return y;
          })
        )
        .subscribe(
          (trips) => {
            this.trips = trips;
            this.ready = true;
            this.loader.dismiss();
          },
          (error) => {
            console.log(error);
            this.ready = true;
            this.loader.dismiss();
          }
        );
    }
  }

  getAlarms(): void {
    this.loader.present();

    this.starms
      .get(["events/trains", this.id], {
        eventType: "250",
        to: moment(this.to).add(1, "day").format("YYYY-MM-DDT00:00:00"),
        tagIdentifierOption: "1",
        from: this.from,
      })
      .subscribe(
        (alarms) => {
          this.alarms = Enumerable.from(alarms)
            .orderByDescending((x) => x["siteTime"])
            .toArray();
          this.ready = true;
          this.loader.dismiss();
        },
        (error) => {
          this.ready = true;
          this.loader.dismiss();
        }
      );
  }

  changeFilter(newValue: string): void {
    this.filter = newValue;
  }
}



// WEBPACK FOOTER //
// ./src/pages/kpi-details/kpi-details.ts